export default {
    email: {
        message: 'Invalid email address.'
    },
    required: {
        message: '<%= name %> is required.',
        placeholderDefaults: {
            name: 'This field'
        }
    } ,
    sameAs: {
        message: '<%= name %> must match <%= eq %>.',
        placeholderDefaults: {
            name: 'This field',
            eq: 'the field above'
        }
    },
    minLength: {
        message: '<%= name %> must be at least <%= min %> long.',
        placeholderDefaults: {
            name: 'This field',
            min: '-1'
        }
    },
    maxLength: {
        message: '<%= name %> must be at most <%= max %> long.',
        placeholderDefaults: {
            name: 'This field',
            max: '-1'
        }
    },
    creditCard: {
        message: 'Invalid card number.',
    },
    cardType: {
        message: 'Invalid card type.',
    }
};
